module.exports = __webpack_public_path__ + "img/07_maska_pyatno_2.bdd6663.svg";